import { alarmToggleActions } from '../../actions';
import { RowItemType, Section, UIElementType } from '../../models';
import { REGEX_CONFIG } from 'app/shared/utils/regex-utils';
import { RainAlarmFieldIds, RainSectionIds } from './base-config-models';
import { field } from '../../core/field-schema';
import { pattern, required } from '../../core/validator-builders';
import { RainAlertLocationCardState } from './models';
import { roundToDecimal } from '../../models/utils';

/**
 * Rain Alarm Configuration Section
 */
export const rainAlarm = (state: RainAlertLocationCardState): Section => {
    const config = state.monitorConfiguration;
    const isMetric = state.settings.isMetric;
    const alarmValidators = [
        required(),
        pattern({
            value: REGEX_CONFIG.numeric0_100000With2DecimalPlacesPattern,
            message: 'COMMON.NUMERIC_PRECISION_ERROR',
        }),
    ];

    return {
        info: {
            id: RainSectionIds.RainAlarm,
            title: 'ADD_EDIT.ADD_EDIT_CONFIGURE',
            displayTitle: true,
            expandable: true,
            expanded: false,
            panelClass: !state.permissions.isMonitorEditor ? 'rain-alarm-section disable-field' : 'rain-alarm-section',
        },
        rows: [
            // Row 1: Rain Alarm Toggle and Threshold
            {
                info: {
                    id: 'rain-alarm-row',
                    panelClass: 'custom-50p',
                },
                items: [
                    field.toggle(RainAlarmFieldIds.AlarmEnable, 'alarmEnable', {
                        label: 'ADD_EDIT.RAIN_ALARMS',
                        value: config ? config.alarmenable : false,
                        panelClass: 'custom-width',
                        events: {
                            onChange: (value) => [
                                ...alarmToggleActions(value, RainAlarmFieldIds.AlarmThreshold, alarmValidators),
                                ...alarmToggleActions(value, RainAlarmFieldIds.AlarmReturnToNormal, alarmValidators),
                            ],
                        },
                    }),
                    field.number(RainAlarmFieldIds.AlarmThreshold, 'alarmThreshold', {
                        placeholder: 'ADD_EDIT.RAIN_THRESHOLD',
                        value: config ? roundToDecimal(config.alarmthreshold, isMetric ? 1 : 2) : 0,
                        decimalPlaces: isMetric ? 1 : 2,
                        disabled: !config || !config.alarmenable,
                        panelClass: 'custom-width',
                        validators: alarmValidators,
                    }),
                ],
            },

            // Row 2: Return To Normal
            {
                info: {
                    id: 'return-to-normal-row',
                    panelClass: 'custom-50p',
                },
                items: [
                    {
                        id: 'return-label',
                        type: RowItemType.UI,
                        uiType: UIElementType.Text,
                        label: 'ADD_EDIT.RETURN_TO_NORMAL',
                        textClass: 'input-text',
                        panelClass: 'custom-width',
                    },
                    field.number(RainAlarmFieldIds.AlarmReturnToNormal, 'alarmReturnToNormal', {
                        placeholder: 'ADD_EDIT.THRESHOLD',
                        value: config ? roundToDecimal(config.alarmreturntonormal, isMetric ? 1 : 2) : 0,
                        decimalPlaces: isMetric ? 1 : 2,
                        disabled: !config || !config.alarmenable,
                        panelClass: 'custom-width',
                        validators: [
                            pattern({
                                value: REGEX_CONFIG.numeric0_100000With2DecimalPlacesPattern,
                                message: 'COMMON.NUMERIC_PRECISION_ERROR',
                            }),
                        ],
                    }),
                ],
            },
        ],
    };
};
